




















































import Vue, { VueConstructor } from "vue";
import ItemAdminLinks from "@/components/ItemAdminLinks.vue";

// Value between 0 and 1 indicating how quickly a letter is registered while dragging
const CELL_SENSITIVITY = 0.6;

const CELL_LOWER_THRESHOLD = (1 - CELL_SENSITIVITY) / 2;
const CELL_UPPER_THRESHOLD = 1 - CELL_LOWER_THRESHOLD;

export default (Vue as VueConstructor<
  Vue & {
    $refs: {
      input: InstanceType<typeof HTMLInputElement>,
    };
  }
>).extend({

    components: {
        ItemAdminLinks,
    },

    props: {
        item: {
            type: Object,
            default: null
        },
    },

    data() {
        return {
            isMouseDown: false,
            input: '',
            ox: 0,
            oy: 0,
        };
    },

    computed: {
        loggedIn(): boolean {
            return this.$store.state.user && !this.$store.state.user.anon;
        },
    },

    mounted() {
        document.body.addEventListener('keydown', this.keyUp);
        document.body.addEventListener('mouseup', this.mouseUp);
        if (this.$refs.input)
            this.$refs.input.focus();
    },

    beforeDestroy() {
        document.body.removeEventListener('keydown', this.keyUp);
        document.body.removeEventListener('mouseup', this.mouseUp);
    },

    methods: {
        rotate(dx: number, dy: number) {
            this.ox = (this.ox + this.item.size - dx) % this.item.size;
            this.oy = (this.oy + this.item.size - dy) % this.item.size;
        },

        keyUp(e: KeyboardEvent) {
            let prevent = false;
            switch (e.code) {
            case "ArrowUp":
                this.rotate(0, -1);
                prevent = true;
                break;
            case "ArrowDown":
                this.rotate(0, 1);
                prevent = true;
                break;
            case "ArrowLeft":
                this.rotate(-1, 0);
                prevent = true;
                break;
            case "ArrowRight":
                this.rotate(1, 0);
                prevent = true;
                break;
            }
            if (prevent) {
                e.stopPropagation();
                e.preventDefault();
            }
        },

        square(x: number, y: number): any {
            const size = this.item.size;
            x = (x + this.ox) % size;
            y = (y + this.oy) % size;
            return this.item.goggle[y * this.item.size + x];
        },

        mouseDown(e: MouseEvent): void {
            //window.console.log('mouse down', e);
            this.isMouseDown = true;
            const td = e.target as HTMLElement;
            if (td.nodeName.toLowerCase() === 'td') {
                this.clickCell(e);
                td.setAttribute('data-output', '1');
            }
            //el.setPointerCapture(e.pointerId);
            //window.console.log(`captured by ${el}`);
        },

        mouseUp(e: MouseEvent): void {
            if (this.isMouseDown) {
                //window.console.log('mouse up', e);
                this.isMouseDown = false;
            }
        },

        mouseEnter(e: MouseEvent): void {
            (e.target as HTMLElement).setAttribute('data-output', "0");
        },

        mouseLeave(e: MouseEvent): void {
            (e.target as HTMLElement).setAttribute('data-output', "0");
        },

        mouseMove(e: MouseEvent): void {
            if (this.isMouseDown) {
                const rect = (e.target as HTMLElement).getBoundingClientRect();
                const x = e.clientX - rect.left; //x position within the element.
                const y = e.clientY - rect.top;  //y position within the element.
                const rw = rect.right - rect.left + 1;
                const rh = rect.bottom - rect.top + 1;
                if (x > rw * CELL_LOWER_THRESHOLD && x < rw * CELL_UPPER_THRESHOLD &&
                    y > rh * CELL_LOWER_THRESHOLD && y < rh * CELL_UPPER_THRESHOLD) {
                    //window.console.log('mouse move', e);

                    const td = e.target as HTMLElement;
                    if (td.getAttribute('data-output') === '0') {
                        td.setAttribute('data-output', '1');
                        this.clickCell(e);
                    }
                }
            }
        },

        clickCell(e: MouseEvent) {
            const letter = (e.target as HTMLElement).innerText.trim();
            this.input += letter.toLowerCase();
        },

        enterWord() {
            this.$store.dispatch('enterGoggleWord', this.input);
            this.input = '';
        },
    },

});
